<template>
  <div
    class="bottom-nav fixed bottom-0 z-[25] flex w-full justify-center bg-white/80 backdrop-blur-[16px] py-2 shadow-[0_-2px_8px_rgba(0,0,0,0.1)] sm:px-2"
    :class="{ 'is-active': shouldShowCta, 'is-hidden': !shouldShowCta }"
  >
    <div class="flex w-full max-w-[1136px] items-center gap-4 px-2 md:mx-auto md:px-0">
      <div class="bottom-nav__text hidden min-w-0 flex-1 flex-col justify-center md:flex">
        <span class="bottom-nav__tag mb-1 self-start bg-light-bg-inset text-light-fg-accent">{{ itineraryTagLabel }}</span>
        <p class="line-clamp-2">{{ title }}</p>
      </div>
      <div class="bottom-nav__button mx-auto flex h-12 w-[calc(100%-16px)] max-w-[330px] items-center justify-center md:mx-0 md:w-auto md:min-w-[180px] md:max-w-[368px] md:flex-1">
        <AtomsPrimaryButton class="h-full w-full whitespace-nowrap" :on-click="onClickOpenRequest">Request itinerary arrangements</AtomsPrimaryButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useWindowScroll } from '@vueuse/core';

import AtomsPrimaryButton from '@/components/atoms/PrimaryButton/PrimaryButton.vue';
import { useSafeWindow } from '@/composables/utils/useSafeWindow';
import { useScrollSensor } from '@/composables/utils/wabunka/useScrollSensor';

interface Props {
  title: string;
  /** 日数に応じたタグ（getItineraryTagLabel で取得したラベル） */
  itineraryTagLabel: string;
  /** 「Request itinerary arrangements」押下時に合わせドロワーを開く */
  onClickOpenRequest: () => void;
}

defineProps<Props>();

// ボタン押下で親の openContactDrawer が呼ばれ、問い合わせドロワーが開く
const { window } = useSafeWindow();
const { isScrollingUp } = useScrollSensor(window);
const { y: scrollY } = useWindowScroll();

/** ページ上部（scrollTop === 0）ではCTAバーを非表示。タイトルと重ならないようにする */
const shouldShowCta = computed(() => isScrollingUp.value && scrollY.value > 0);
</script>

<style scoped>
.bottom-nav {
  &.is-active {
    animation: slideUp 0.3s;
  }
}

.bottom-nav__text {
  align-items: flex-start;
}

.bottom-nav__tag {
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1.4;
}

.bottom-nav__text p {
  color: var(--foreground-fg-default, var(--Foreground-default, #423d36));
  font-family: Spectral, serif;
  font-size: var(--font-size-p2, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--line-height-p2, 24px);
}

.bottom-nav.is-hidden {
  opacity: 0;
  pointer-events: none;
  transform: translateY(100%);
}

@keyframes slideUp {
  0% {
    bottom: -50px;
    opacity: 0;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
</style>
